/// <reference path="../../app.definition.ts" />

import moment from "moment";
import { Serializable } from "./Serializable";

export class Invitation implements Serializable<Invitation> {

  accepted;
  acceptedDate;
  acceptorId;
  email; // acceptor email
  inviteDate;
  inviterName;
  inviterPhoto: string = null;
  subjectId : number | string;
  userId; //inviterId
  suggested;
  processed;
  token: string;
  ignored: boolean;
  lastInvitedBeforeHours: number;
  inviterInitials: string;
  adminInvite: string;
  status: string;
  inviter: any;

  deserialize(input) {
    if (input.accepted == false || input.accepted == true)
      this.accepted = input.accepted;
    else
      this.accepted = null;
    (input.userId) && (this.userId = input.userId);
    (input.subjectId) && (this.subjectId = input.subjectId);
    (input.inviterName) && (this.inviterName = input.inviterName);
    this.inviterPhoto = input.inviterPhoto;
    (input.inviteDate) && (this.inviteDate = input.inviteDate);
    (input.acceptorId) && (this.acceptorId = input.acceptorId);
    (input.acceptedDate) && (this.acceptedDate = input.acceptedDate);
    input.email && (this.email = input.email);
    if (input.suggested == false || input.suggested == true)
      this.suggested = input.suggested;
    else
      this.suggested = null;
    if (input.processed == false || input.processed == true)
      this.processed = input.processed;
    else
      this.processed = null;

    this.token = input.token;
    this.ignored = input.ignored;
    this.adminInvite = input.adminInvite;
    this.status = input.status;

    if (this.inviterName != null || this.inviterName != undefined) {
      var name = this.inviterName.split(" ", 2);
      this.inviterInitials = (name[0].substring(0, 1).toUpperCase() + (!!name[1] ? name[1].substring(0, 1).toUpperCase() : ''));
    }
    if (this.suggested == true &&
      this.accepted == false &&
      this.processed == false) {
      this.lastInvitedBeforeHours = -1;
    } else {
      var inviteDate = moment(this.inviteDate);
      var todaysDate = moment(new Date());
      this.lastInvitedBeforeHours = todaysDate.diff(inviteDate, 'hours');
    }
    return this;
  }

  constructor() {
  }

}
